import { LargeSpinner, Spinner } from "components/Loading";
import { SpoilerText, Table } from "components/PuzzleContent/puzzle-components";
import Twemoji from "react-twemoji";
import {
  useTeamScopeState,
  useAccessiblePuzzles,
} from "stores/ScopeStateStore";
import "./Atoll.css";
import { PuzzleLink } from "components/Link";
import { AtollRegionSymbol } from "components/Region";

const MAGIC_NUMBER = [
  ["3b10f911", 7],
  ["36e6dcfc", 7],
  ["15bba02c", 4],
  ["1c4e33f7", 7],
  ["882d11bf", ""],
  ["bb3385d6", 11],
  ["3f18f1dd", 9],
  ["891f6fdd", 7],
] as const;

const OTHER_MAGIC_NUMBER = {
  "3b10f911": 4,
  "36e6dcfc": 4,
  "15bba02c": 3,
  "1c4e33f7": 4,
  "882d11bf": 3,
  bb3385d6: 6,
  "3f18f1dd": 5,
  "891f6fdd": 4,
} as const;

export function Atoll() {
  const teamScopeState = useTeamScopeState();
  if (teamScopeState === null) return <LargeSpinner />;

  const data = Object.values(teamScopeState.puzzles)
    .filter(({ puzName }) => MAGIC_NUMBER.some(([puz]) => puz === puzName))
    .sort((a, b) =>
      a.displayName
        .toLowerCase()
        .replace(/[^a-z]/g, "")
        .localeCompare(b.displayName.toLowerCase().replace(/[^a-z]/g, ""))
    )
    .map((puzData) => {
      return {
        name: puzData.displayName,
        info: puzData.answer
          ? MAGIC_NUMBER.find(([puz]) => puz === puzData.puzName)![1]
          : "❓",
      };
    });

  return (
    <table className="atoll">
      <tbody>
        {data.map(({ name, info }, i) => (
          <tr key={i}>
            <td>{name}</td>
            <td>
              <Twemoji>{info}</Twemoji>
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
}

export function AtollTable({ i }: { i: number }) {
  const puzzles = useAccessiblePuzzles();
  if (puzzles === null) return <Spinner />;

  if (i === 1) {
    return (
      <Table
        headers={["Island", "Slices"]}
        cells={[
          [<AtollRegionSymbol key={0} islandId={0} />, "C1"],
          [<AtollRegionSymbol key={1} islandId={1} />, "A2, C3"],
          [<AtollRegionSymbol key={2} islandId={2} />, "B1"],
          [<AtollRegionSymbol key={3} islandId={3} />, "G4"],
          [<AtollRegionSymbol key={4} islandId={4} />, "A1"],
          [<AtollRegionSymbol key={5} islandId={5} />, "G1"],
          [<AtollRegionSymbol key={6} islandId={6} />, "B2, D1, G3, H4"],
          [<AtollRegionSymbol key={7} islandId={7} />, "B4, F6, G5"],
          [<AtollRegionSymbol key={8} islandId={8} />, "F1"],
          [<AtollRegionSymbol key={9} islandId={9} />, "E1, F3, H3"],
          [<AtollRegionSymbol key={10} islandId={10} />, "D2, E3, F5"],
          [<AtollRegionSymbol key={11} islandId={11} />, "(none)"],
        ]}
      />
    );
  }

  return (
    <Table
      headers={[
        "Letter",
        "Title",
        "Answer",
        "Number of pieces",
        "Extra number",
      ]}
      cells={MAGIC_NUMBER.map(([puzName, info], i) => [
        "ABCDEFGH"[i],
        <PuzzleLink key={i} puzName={puzName} subpage="puzzle" />,
        <SpoilerText key={i}>{puzzles[puzName].answer}</SpoilerText>,
        OTHER_MAGIC_NUMBER[puzName],
        info || "None",
      ])}
    />
  );
}
